// A pasted image sits in the doc on its local preview URL until its upload lands.
export const isUploadingImageSrc = (src: unknown): boolean => typeof src === 'string' && src.startsWith('blob:');
